<template>
  <rx-login-form>
    <!-- <rx-locale slot="append-header-right" text color="rx-foreground pri-3"></rx-locale> -->
  </rx-login-form>
</template>

<script>
// 로그인 폼 컴포넌트 import
import RxLoginForm from "@/redworks/components/auth/RxLoginForm";
// import RxLocale from "@/redworks/components/common/RxLocale";
// import { mapGetters } from "vuex";
export default {
  components: {
    RxLoginForm,
    // RxLocale,
  },
  computed: {
    /* ...mapGetters("app",{
      defaultTheme: "getTheme"
    }) */
  },
  mounted() {
    // this.$vuetify.theme.themes.light = this.defaultTheme.theme.themes.light;
  },
};
</script>
